import { Box, Typography } from "@mui/material";
import FadeInSection from "../../../../components/@extended/containers/FeadeInSection";
import { useTheme } from "@emotion/react";
import ContactForm from "./ContactForm";
import PrimaryHeading from "../../../../components/@ui/headings/PrimaryHeading";
import useBreakpoint from "../../../../hooks/useBreakpoint";
import PrimaryDesc from "../../../../components/@ui/descriptions/PrimaryDesc";
import ScrollSectionContainer from "../../../../components/@extended/containers/ScrollSection";
import SlideInOutSection from "../../../../components/@extended/containers/SlideInOutSection";

export default function Contact() {
  const breakpont = useBreakpoint();
  const largeScreens = ["xl", "lg"].includes(breakpont);
  return (
    <SlideInOutSection>
      <Box className="p-[10px]" id="contact-section">
        <Box
          component="section"
          className="section-container overflow-hidden bg-paper rounded-[8px] py-[3rem]"
        >
          <Box className="section-content-container flex justify-between items-center gap-6 flex-col lg:flex-row">
            <Box className={`flex-1`}>
              {largeScreens && (
                <Box className={`h-full`}>
                  <img
                    src={"assets/images/images/boy-supermart.png"}
                    alt={"kid in supermart using priseen app"}
                    className="w-full h-full object-contain transition-all transform"
                  />
                </Box>
              )}
            </Box>

            {/* Form */}
            <Box className="relative w-full flex-1 flex flex-col gap-[20px]">
              <PrimaryHeading size={largeScreens ? "small" : "large"}>
                Interested to discuss?
              </PrimaryHeading>
              <PrimaryDesc>
                {
                  "Please fill the form and submit. We will get back to you soon!"
                }
              </PrimaryDesc>
              <ContactForm />
            </Box>
          </Box>
        </Box>
      </Box>
    </SlideInOutSection>
  );
}
